<template>
  <v-dialog :value="visibility" fullscreen>
    <v-card>
      <v-card-title class="headline">Cadastrar aula</v-card-title>

      <v-card-text>
        <CreateClassForm :subjects="subjects" ref="classForm" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded depressed @click="$emit('negative')">
          Cancelar
        </v-btn>
        <v-btn color="primary" rounded depressed @click="$emit('positive', $refs.classForm.form)">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CreateClassForm from "@/components/forms/CreateClassForm";

export default {
  components: {
    CreateClassForm
  },
  props: {
    subjects: Array,
    visibility: Boolean
  },
  data() {
    return {
      dialog: undefined
    };
  },
  mounted() {
    this.dialog = this.visibility;
  }
};
</script>
